import React from 'react'
import FormRadio from '../../../../components/FormControlled/FormRadio'
import { Control, FieldValues, Path } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type Props<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
}
export const VehicleCargoOptions = {
  NoElectricOrHybridVehicleCargo: {
    value: 'no-electric-or-hybrid-vehicle-cargo',
    label: 'vehicle_cargo_confirmation_no_electric_or_hybrid',
    infoText: 'No electric or hybrid vehicles are being transported.'
  },
  VehicleCargoInGoodCondition: {
    value: 'vehicle-cargo-in-good-condition',
    label: 'vehicle_cargo_confirmation_good_condition',
    infoText: 'Transported vehicle is in good condition for transport.'
  }
} as const

const VehicleCargoConfirmation = <T extends FieldValues>({
  control,
  name
}: Props<T>) => {
  const { t } = useTranslation()
  return (
    <FormRadio
      name={name}
      label={t('vehicle_cargo_responsibility_disclaimer')}
      control={control}
      rules={{ required: 'This field is required' }}
      options={Object.values(VehicleCargoOptions).map(({ value, label }) => ({
        value,
        label: t(label)
      }))}
      stackDirection="column"
      setDefaultValue={false} // don't set default value to force user to make a choice
    />
  )
}
export default VehicleCargoConfirmation
